 // mediaManagment/image_types

import { Media            ,
         initializedMedia } from './types';

export interface Image extends Media
 {
  visible     : string ,
  title       : string ,
  description : string ,
  imageFile   : string ,
  fileBlob?   : Blob;    // Blob téléchargé
  objectURL?  : string;  // URL locale (via URL.createObjectURL)
 }

export const initializedImage = (): Image => (
 {
  ...initializedMedia()                       ,
  visible     : "" ,
  title       : "" ,
  description : "" ,
  imageFile   : ""    ,
  fileBlob    : undefined,
  objectURL   : undefined,  
});
